function numberValue(value) {
    if (value === '' || value === null || typeof value === 'undefined') {
        return undefined;
    }

    const parsed = Number(value);

    return Number.isFinite(parsed) ? parsed : undefined;
}

export function normaliseEntitlements(value) {
    let values = value;

    if (values && !Array.isArray(values) && Array.isArray(values.data)) {
        values = values.data;
    }

    if (values && !Array.isArray(values) && Array.isArray(values.entitlements)) {
        values = values.entitlements;
    }

    if (!Array.isArray(values)) return [];

    return [...new Set(
        values
            .filter((item) => typeof item === 'string')
            .map((item) => item.trim())
            .filter(Boolean)
    )];
}

export function normaliseEntitlementCatalog(response) {
    const payload = response?.data ?? response;

    return normaliseEntitlements(payload);
}

export function normaliseVoucher(value = {}) {
    const raw = value?.voucher || value?.data || value || {};
    const id = raw.id ?? raw.publicId ?? raw.public_id;

    return {
        ...raw,
        id,
        publicId: raw.publicId ?? raw.public_id ?? id,
        companyId: raw.companyId ?? raw.company_id,
        isActive: raw.isActive ?? raw.is_active,
        expiresAt: raw.expiresAt ?? raw.expires_at,
        entitlements: normaliseEntitlements(raw.entitlements)
    };
}

export function normaliseVoucherList(response) {
    const payload = response?.data ?? response;
    const rows = Array.isArray(payload)
        ? payload
        : Array.isArray(payload?.data)
            ? payload.data
            : Array.isArray(payload?.vouchers)
                ? payload.vouchers
                : [];

    return rows.map(normaliseVoucher);
}

export function normaliseVoucherMeta(response, fallback = {}) {
    const payload = response?.data ?? response ?? {};
    const meta = payload.meta || payload;

    return {
        total: Number(meta.total ?? fallback.total ?? 0),
        currentPage: Number(meta.currentPage ?? meta.current_page ?? fallback.currentPage ?? 1),
        perPage: Number(meta.perPage ?? meta.per_page ?? fallback.perPage ?? 50),
        lastPage: Number(meta.lastPage ?? meta.last_page ?? fallback.lastPage ?? 1)
    };
}

export function buildVoucherCreatePayload(values = {}) {
    return {
        companyId: numberValue(values.companyId),
        months: numberValue(values.months),
        entitlements: normaliseEntitlements(values.entitlements)
    };
}

export function buildVoucherBulkCreatePayload(values = {}) {
    return {
        companyId: numberValue(values.companyId),
        count: numberValue(values.count),
        entitlements: normaliseEntitlements(values.entitlements)
    };
}

/**
 * Update payloads deliberately distinguish edited fields from the values
 * loaded into the form. An omitted field keeps its server value; an edited
 * entitlement list may therefore be [] to clear all perks.
 * @param {Object} values
 * @param {Object|Boolean} editedFields
 * @returns {Object}
 */
export function buildVoucherUpdatePayload(values = {}, editedFields = {}) {
    const entitlementsEdited = editedFields === true || editedFields.entitlements === true;

    return entitlementsEdited
        ? { entitlements: normaliseEntitlements(values.entitlements) }
        : {};
}

export function getVoucherErrorMessage(error, fallback = 'Could not save voucher.') {
    const response = error?.response;
    const body = response?.data;
    const validationErrors = body?.errors;

    if (validationErrors && typeof validationErrors === 'object') {
        const messages = Object.values(validationErrors)
            .flatMap((value) => Array.isArray(value) ? value : [value])
            .filter(Boolean);

        if (messages.length) return messages.join(' ');
    }

    return body?.message || error?.message || fallback;
}
